declare const __API_URL__: string;

export function useServerUrl() {
  // Use the API URL since we're using a single backend service now
  return __API_URL__;
}
